import React from 'react';
import { FadeIn, Section } from '../ui/Shared';
export const AgitationSection = () => {
  const pains = [{
    icon: '🌀',
    title: 'El ciclo que se repite',
    desc: 'Intentás estar mejor. Mejorás unos días. Y volvés al mismo punto de agotamiento, culpa y tristeza. No porque seas débil — sino porque sin las herramientas correctas, el ciclo siempre regresa.'
  }, {
    icon: '😔',
    title: 'La culpa que no te deja',
    desc: 'Amás a tu bebé con toda tu alma. Pero a veces sentís alivio cuando duerme. O tristeza sin motivo. O ganas de escapar aunque sea cinco minutos. Y después viene la culpa por haberlo sentido.'
  }, {
    icon: '🌙',
    title: 'El agotamiento que no cierra',
    desc: 'Dormís poco y mal. Tu mente no para ni cuando el bebé duerme. La ansiedad nocturna se instaló. Y el descanso que necesitás parece un lujo imposible.'
  }, {
    icon: '💭',
    title: 'Los pensamientos que asustan',
    desc: '"¿Voy a volver a ser yo?" "¿Esto es normal?" "¿Por qué no puedo disfrutarlo más?" Pensamientos que no le contás a nadie porque tenés miedo de lo que van a pensar.'
  }];
  return <Section className="bg-pink-light" data-id="element-104" data-mp="3b17m7674uels">
      <FadeIn data-id="element-105" data-mp="3b293hseqrxby">
        <h2 className="text-3xl md:text-5xl text-center mb-10 italic" data-id="element-106" data-mp="3b2slf94e6lpz">
          Lo que nadie te contó sobre el postparto
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-2 gap-5 max-w-4xl mx-auto" data-id="element-107" data-mp="329p9545hgewx">
        {pains.map((pain, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-108" data-mp="3pz9u1sl75m8u" data-mpi={i}>
            <div className="bg-white p-6 rounded-2xl border border-pink-border shadow-sm hover:shadow-md transition-shadow h-full flex gap-4" data-id="element-109" data-mp="3pw4307t0caah">
              <div className="text-4xl shrink-0" data-id="element-110" data-mp="3g0u1rmafo6xr">{pain.icon}</div>
              <div data-id="element-111" data-mp="3g2etz599zdsg">
                <h3 className="text-xl font-bold text-pink-deep mb-2 font-heading" data-id="element-112" data-mp="3kyvnkez8ukcx">
                  {pain.title}
                </h3>
                <p className="text-brown-text/80 leading-relaxed" data-id="element-113" data-mp="24k44wtrwgrgt">
                  {pain.desc}
                </p>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="mt-10 text-center max-w-2xl mx-auto" data-id="element-114" data-mp="1pgsuy2b05zdl">
        <p className="text-xl italic font-heading text-celeste-deep font-medium" data-id="element-115" data-mp="1lgis2yiibp2y">
          El problema no sos vos. Es que estás intentando atravesar uno de los
          cambios más profundos de tu vida sin un mapa.
        </p>
      </FadeIn>
    </Section>;
};
export const MechanismSection = () => {
  const pillars = [{
    icon: '🌸',
    title: 'Tu cuerpo',
    desc: 'Cambios hormonales, agotamiento físico, desconexión de tu propio cuerpo'
  }, {
    icon: '💙',
    title: 'Tu mente',
    desc: 'Ansiedad, pensamientos negativos, dificultad para descansar, montaña rusa emocional'
  }, {
    icon: '✨',
    title: 'Tu identidad',
    desc: 'Sentís que "la mamá" reemplazó a la mujer que eras. No sabés quién sos en esta nueva etapa'
  }];
  return <Section className="bg-celeste-light" data-id="element-116" data-mp="2s47a1j0u350b">
      <FadeIn className="text-center max-w-3xl mx-auto mb-10" data-id="element-117" data-mp="2n5vxh0j5mgee">
        <h2 className="text-3xl md:text-5xl mb-6" data-id="element-118" data-mp="2n6e5euf6ij25">
          ¿Por qué lo que probaste hasta ahora no alcanzó?
        </h2>
        <p className="text-lg mb-3" data-id="element-119" data-mp="2zo8e8kv44xel">
          Porque el postparto no es solo un tema del cuerpo.
        </p>
        <p className="text-lg mb-6" data-id="element-120" data-mp="34f6w3ovr23jy">
          No se resuelve solo con descanso, con "pensar positivo" o con el
          tiempo.
        </p>
        <p className="text-xl font-bold text-celeste-deep" data-id="element-121" data-mp="39cqb4r09ukcy">
          El postparto impacta en tres niveles simultáneamente:
        </p>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-10" data-id="element-122" data-mp="2gpcgx0nyk2wj">
        {pillars.map((pillar, i) => <FadeIn key={i} delay={i * 0.15} data-id="element-123" data-mp="2lop6ht67ro2t" data-mpi={i}>
            <div className="bg-white/60 backdrop-blur-sm p-6 rounded-2xl text-center h-full border border-white shadow-sm" data-id="element-124" data-mp="2lnnqrbe96der">
              <div className="text-5xl mb-4" data-id="element-125" data-mp="2pny08y197lyd">{pillar.icon}</div>
              <h3 className="text-2xl font-bold text-pink-deep mb-3 font-heading" data-id="element-126" data-mp="x6my6egjs4r">
                {pillar.title}
              </h3>
              <p className="text-brown-text/80" data-id="element-127" data-mp="51wgholn8umi">{pillar.desc}</p>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="text-center max-w-2xl mx-auto bg-white p-6 rounded-2xl shadow-sm border border-celeste-primary/20" data-id="element-128" data-mp="3kh8qe9gmcug">
        <p className="font-bold text-lg mb-3" data-id="element-129" data-mp="dh3tl31sd3wh">
          Para sanar de verdad, necesitás trabajar los tres — al mismo tiempo,
          con un método claro y amoroso.
        </p>
        <p className="italic text-pink-deep font-heading text-xl" data-id="element-130" data-mp="mh8seoswytz1">
          Eso es exactamente lo que hace Renacer Después del Parto.
        </p>
      </FadeIn>
    </Section>;
};